import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../js/coreRuntime.mjs';
import { KTypeParameter1s8efufd4mbj5 as KTypeParameter } from './KTypeParameter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { KClass1cc9rfeybg8hs as KClass } from './KClassJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../Char.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KTypeImplClass;
function KTypeImpl() {
  if (KTypeImplClass === VOID) {
    class $ {
      constructor(classifier, arguments_0, isMarkedNullable) {
        this.classifier_1 = classifier;
        this.arguments_1 = arguments_0;
        this.isMarkedNullable_1 = isMarkedNullable;
      }
      get_classifier_ottyl2_k$() {
        return this.classifier_1;
      }
      get_arguments_p5ddub_k$() {
        return this.arguments_1;
      }
      get_isMarkedNullable_4el8ow_k$() {
        return this.isMarkedNullable_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof KTypeImpl()) {
          tmp_1 = equals(this.classifier_1, other.classifier_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.arguments_1, other.arguments_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.isMarkedNullable_1 === other.isMarkedNullable_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.classifier_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        return imul(imul(tmp$ret$0, 31) + hashCode(this.arguments_1) | 0, 31) + getBooleanHashCode(this.isMarkedNullable_1) | 0;
      }
      toString() {
        var tmp0_subject = this.classifier_1;
        var tmp;
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KClass()) : false) {
          var tmp1_elvis_lhs = this.classifier_1.get_qualifiedName_aokcf6_k$();
          tmp = tmp1_elvis_lhs == null ? this.classifier_1.get_simpleName_r6f8py_k$() : tmp1_elvis_lhs;
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, KTypeParameter()) : false) {
            tmp = this.classifier_1.get_name_woqyms_k$();
          } else {
            tmp = null;
          }
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          return '???';
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var classifierString = tmp_0;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this_0.append_22ad7x_k$(classifierString);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.arguments_1.isEmpty_y1axqb_k$()) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(60));
          var iterator = this.arguments_1.iterator_jk1svi_k$();
          var index = 0;
          while (iterator.hasNext_bitz1p_k$()) {
            var index_0 = index;
            index = index + 1 | 0;
            var argument = iterator.next_20eer_k$();
            if (index_0 > 0) {
              this_0.append_22ad7x_k$(', ');
            }
            this_0.append_t8pm91_k$(argument);
          }
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(62));
        }
        if (this.isMarkedNullable_1) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(63));
        }
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'KTypeImpl');
    KTypeImplClass = $;
  }
  return KTypeImplClass;
}
//region block: exports
export {
  KTypeImpl as KTypeImpl24ni3lyofhkxw,
};
//endregion

//# sourceMappingURL=KTypeImpl.mjs.map
